import apolloClient from 'store/apolloClient';
import apiCall from 'shared/utils/apiCall';
import createAsyncAction from 'shared/utils/createAsyncAction';

import { SELECT_ORGANIZATION_TOKEN } from 'modules/auth/actions/organizationSelection';
import * as services from '../services/session';
import createAction from './';

export const GET_SESSION_INFO = createAsyncAction(createAction('GET_SESSION_INFO'));

export const getSessionInfo = ({ background } = {}) => (dispatch) => {
  if (!background) dispatch({ type: GET_SESSION_INFO.pending });

  const apiCallParams = {
    query: services.GET_SESSION_INFO,
    fetchPolicy: 'no-cache',
  };

  return apiCall(apolloClient.query, apiCallParams)
    .then(
      ({
         data: {
           session: {
             sessionId,
             user,
             permissions,
             activeConversations,
           },
         },
       }) => {
        dispatch({
          type: GET_SESSION_INFO.success,
          payload: {
            sessionId,
            user,
            permissions,
            activeConversations,
          },
        });
        return dispatch({
          type: SELECT_ORGANIZATION_TOKEN,
          payload: { selectedOrganizationToken: user.orgId },
        });
      },
    )
    .catch((e) => {
      console.error(e);
      dispatch({ type: GET_SESSION_INFO.failure });
      throw Error;
    });
};
